import classNames from 'classnames';
import "./style";
import { jsx as _jsx } from "react/jsx-runtime";
var IglooTypography = function IglooTypography(_ref) {
  var level = _ref.level,
    children = _ref.children,
    className = _ref.className,
    _ref$wrapElement = _ref.wrapElement,
    wrapElement = _ref$wrapElement === void 0 ? 'span' : _ref$wrapElement,
    style = _ref.style,
    title = _ref.title,
    onClick = _ref.onClick;
  var prefix = 'igloo-typography-';
  var classNameObj = {};
  if (Array.isArray(level)) {
    level.map(function (item) {
      classNameObj[prefix + item] = true;
    });
  } else {
    classNameObj[prefix + level] = true;
  }
  if (wrapElement === 'div') {
    return /*#__PURE__*/_jsx("div", {
      className: classNames(classNameObj, 'word-wrap', className),
      style: style,
      title: title,
      onClick: onClick,
      children: children
    });
  }
  return /*#__PURE__*/_jsx("span", {
    className: classNames(classNameObj, 'word-wrap', className),
    style: style,
    title: title,
    onClick: onClick,
    children: children
  });
};
export default IglooTypography;
IglooTypography.formItemPropsHandler = function () {
  return {
    withoutForm: true,
    fullRow: true
  };
};